/* Enhance Shopify's banner without replacing its consent or preferences handlers. */
(() => {
  const template = document.getElementById('privacy-banner-content');
  if (!template) return;

  function enhanceBanner(banner) {
    if (banner.dataset.privacyStyled) return;
    const body = banner.querySelector('.shopify-pc__banner__body');
    const copy = body?.querySelector('p:last-of-type');
    const buttons = banner.querySelector('.shopify-pc__banner__btns');
    const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
    const decline = banner.querySelector('#shopify-pc__banner__btn-decline');
    const preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    // Leave the native banner usable if Shopify changes its markup or configuration.
    if (!copy || !buttons || !accept || !decline || !preferences) return;

    const content = template.content.cloneNode(true);
    const links = content.querySelector('.privacy-banner__links');
    const close = content.querySelector('.privacy-banner__close');
    banner.dataset.privacyStyled = 'true';
    // Shopify renders the merchant's Cookie banner copy, labels and policy link.
    // Preserve those nodes and their handlers; only move the preferences control.
    const cookies = links.querySelector('.privacy-banner__cookies');
    cookies.textContent = preferences.textContent;
    const policy = body.querySelector('#shopify-pc__banner__body-policy-link');
    if (policy) {
      const policyLink = policy.cloneNode(true);
      policyLink.removeAttribute('id');
      policyLink.classList.add('privacy-banner__policy');
      links.querySelector('.privacy-banner__policy').replaceWith(policyLink);
    }
    copy.append(document.createTextNode(' '), preferences);

    const actions = document.createElement('div');
    actions.className = 'privacy-banner__actions';
    actions.append(decline, accept);
    buttons.replaceChildren(actions, links);
    banner.append(close);
    cookies.addEventListener('click', () => preferences.click());
    // Closing makes the same choice as Reject all; it never grants tracking consent.
    close.addEventListener('click', () => decline.click());
  }

  function findBanner(node) {
    if (!(node instanceof Element)) return;
    const banner = node.id === 'shopify-pc__banner' ? node : node.querySelector('#shopify-pc__banner');
    if (banner) enhanceBanner(banner);
  }

  findBanner(document.body);
  // Shopify injects and recreates its banner asynchronously, including after preferences close.
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) findBanner(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
